import type { AppEnvConfig } from '../appEnvConfig';

// Set these values for deployed development
export const env: AppEnvConfig = {
  REACT_APP_SERVER_URL: 'https://staffing-backend.onrender.com', // https://run.salv.ai
  REACT_APP_PUBLIC_BACKEND_URL: 'https://dev-run.salv.ai',
  REACT_APP_WS_URL: 'wss://staffing-backend.onrender.com', // wss://run.salv.ai
  REACT_APP_DOCS_BASE_URL: 'https://docs.tenzo.ai',
  REACT_APP_STYTCH_PROJECT_ENV: 'test',
  REACT_APP_STYTCH_REDIRECT_URL:
    'https://staffing-frontend.onrender.com/authenticate', // https://chat.salv.ai/authenticate
  REACT_APP_STYTCH_PUBLIC_TOKEN:
    'public-token-test-95ca1437-a1fd-404c-961e-b632b4446c81',
  REACT_APP_INTERVIEW_REDIRECT_URL: 'https://dev-interview.tenzo.ai',
  REACT_APP_DATADOG_RUM_CLIENT_TOKEN: 'pub4179c0c769be99d918030b3199f22b29',
  REACT_APP_DATADOG_RUM_APPLICATION_ID: '1c2a8e12-4a2f-431d-b4c0-4c0298ef452d',
  REACT_APP_ENVIRONMENT: 'deployed-development',
  REACT_APP_GOOGLE_MAPS_API_KEY: 'AIzaSyD1NgAuwTMhFgpUvMpI7PB5a_uMz9psSrQ',
  // OAuth web client id for the Google Meet add-on sign-in flow. See
  // production-deployed.ts for the full requirements.
  REACT_APP_GOOGLE_OAUTH_CLIENT_ID:
    '453144534742-i3b00tlniqp2it1qld6e1cnj0h0prl0q.apps.googleusercontent.com',
};
